import classNames from 'classnames';
import css from './MediaListSkeleton.module.scss';

// Name lengths varied row to row, so the placeholder reads as titles rather than a stripe.
const NAME_WIDTHS = ['46%', '38%', '52%', '31%', '44%', '36%', '49%', '40%'];

/**
 * The list view before the listing has answered, in the page's loading wave (`_skeleton-wave`) —
 * the same wave the folder row and the gallery's cards load in. `table` mirrors the desktop
 * table's row (checkbox, thumbnail, name, a few columns); `compact` the phone list's.
 */
export function MediaListSkeleton({ variant }: { variant: 'table' | 'compact' }) {
  return (
    <div className={classNames(css.list, css[variant])} aria-hidden>
      {NAME_WIDTHS.map((width) => (
        <div key={width} className={css.row}>
          {variant === 'table' && <span className={css.checkbox} />}
          <span className={css.thumbnail} />
          <span className={css.text}>
            <span className={css.name} style={{ width }} />
            {variant === 'compact' && <span className={css.meta} />}
          </span>
          {variant === 'table' && (
            <>
              <span className={css.cell} />
              <span className={css.cell} />
              <span className={css.cell} />
            </>
          )}
        </div>
      ))}
    </div>
  );
}
